import VarietySelectMobile from './VarietySelectMobile';

export default VarietySelectMobile;
